import { render, staticRenderFns } from "./workOrder.vue?vue&type=template&id=dd87865a&scoped=true"
import script from "./workOrder.vue?vue&type=script&lang=js"
export * from "./workOrder.vue?vue&type=script&lang=js"
import style0 from "./workOrder.vue?vue&type=style&index=0&id=dd87865a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd87865a",
  null
  
)

export default component.exports